import { Component, NgZone } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController, ToastController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import { Observable, Subject } from 'rxjs';
import { AngularFireStorage, AngularFireUploadTask } from "@angular/fire/storage";
import * as jsPDF from 'jspdf';
import { SENTREX_LOGO } from '../../providers/images';
import { AngularFirestore } from '@angular/fire/firestore';
import { Storage } from '@ionic/storage';
import { PdfProvider } from '../../providers/pdf/pdf';
import { UtilityProvider } from '../../providers/utility/utility';

@IonicPage()
@Component({
  selector: 'page-supplies',
  templateUrl: 'supplies.html',
})
export class SuppliesPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  public clinic: any = {};
  clinic_name: string;
  clinic_id: string;
  clinic_province: string;
  suppliesList: any[];
  // supplistOrderList: any;
  public doctorList: Observable<any[]>;
  category_previous: string;
  doctor: any;
  public order: any = {};
  notes: string;
  primarylocation: any = {};
  location: any = {};
  email: string = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private auth: AuthProvider,
    private database: DatabaseProvider,
    private afs: AngularFirestore,
    private storage: Storage,
    private afStorage: AngularFireStorage,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public zone: NgZone,
    private pdf: PdfProvider,
    private utility: UtilityProvider
  ) {
    this.clinic['locations'] = [];
    this.clinic.address = {};
    this.auth.getCurrentUser().then(user => {
      this.email = user.email;
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
      this.clinic_province = user.clinic_province;

      this.database.getClinic(this.clinic_id)
        .valueChanges()
        .take(1)
        .subscribe((clinic) => {
          if (clinic) {
            this.clinic = clinic;
            this.primarylocation.name = this.clinic.clinic_name;
            this.primarylocation.address = this.clinic.address.address;
            this.primarylocation.city = this.clinic.address.city;
            this.primarylocation.phone_number = this.clinic.phone_number;
          }
          this.location = this.primarylocation;
        });

      this.database
      .getSupplyByClinic(this.clinic_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          data.quantity = null;
          if(a.payload.doc.data()['clinics_default']) {
            data.default = (a.payload.doc.data()['clinics_default'].includes(this.clinic_id));
            // data.default = (a.payload.doc.data()['clinics_default'].includes(this.clinic_id));
          }
          return data;
        });
      })
      .take(1)
      .subscribe((supplies) => {
        this.suppliesList = supplies;
        // this.supplistOrderList = JSON.parse(JSON.stringify(supplies));
      });

      this.doctorList = this.database
      .getDoctorsByClinic(this.clinic_id)
      .snapshotChanges()
      .take(1)
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      });
    });
  }

  ngOnDestroy() {
    console.log('Leave supplies page and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  showDivider(category: string) {
    if (category !== this.category_previous) {
      this.category_previous = category;
      return true;
    } else {
      this.category_previous = category;
      return false;
    }
    
  }

  checkToggled(clinics) {
    if(clinics) {
      return (clinics.includes(this.clinic_id));
    } else {
      return false;
    }
  }

  submitOrder() {
    let message: string = null;
    const supplies = this.suppliesList.filter(supply => supply.quantity !== null);
    if (supplies.length === 0)  message = '<li>No quantities have been added</li>';
    if (!this.doctor) message += '<li>A doctor has not been slected</li>'

    if (message)  {
      let validationAlert = this.alertCtrl.create({
        title: "Order Issue",
        message: message,
        buttons: [
          {
            text: "OK",
            handler: () => {
              return;
            }
          }]
        });
        validationAlert.present();

      // validationAlert.onDidDismiss().then(()=>{
      //   return;
      // });
    } else {

    let confirm = this.alertCtrl.create({
      title: "Submit To Sentrex",
      message:
        "Are you sure you would like to submit this to Sentrex?",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: async () => {
            console.log('Pre PDF location: ', this.location)
            this.order['email'] = this.email;
            this.order['supplies'] = this.suppliesList.filter(supply => supply.quantity !== null);
            this.order['clinic_id'] = this.clinic_id;
            this.order['clinic_name'] = this.clinic_name;
            this.order['clinic_province'] = this.clinic_province;
            this.order['location'] = this.location;
            this.order['status'] = 'Queued';
            this.order['type'] = 'supplies';
            this.order['doctor'] = this.doctor;
            const newClinicOrderNumber = await this.database.getUniqueClinicOrderNumber(this.clinic_id);
            const newMasterOrderNumber = await this.database.getUniqueMasterOrderNumber();

            const order_number = `ORD${this.utility.pad(newClinicOrderNumber, 5, '0')}`;
            const order_number_master = `ORD${this.utility.pad(newMasterOrderNumber, 9, '0')}`;

            this.order['order_number'] = order_number;
            this.order['order_number_master'] = order_number_master;

            if(!this.notes) { this.notes = null; }
            this.order['note'] = this.notes;

            const loading = this.loadingCtrl.create({});
            loading.present();
            const filepath = await this.pdf.createSupplyPDF(this.clinic, this.order, this.notes, this.location, this.order['order_number']);
            this.order['order_file'] = filepath;

            this.database.saveOrder(this.order, false).then((res) => {
              this.database.incrementClinicOrderNumber(this.clinic_id);
              loading.dismiss();
              this.completedOrderProcessing();
            })
          }
        }
      ]
    });
    confirm.present();
    }
  }

  clearSuppliesOrder()  {
    let confirm = this.alertCtrl.create({
      title: "Reset Supplies Order",
      message:
        "Are you sure you would like to reset this supplies order?",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: () => {
            this.completedOrderProcessing();
          }
        },
      ]});
    confirm.present();
  }

  completedOrderProcessing()  {
    this.suppliesList.forEach((item) => {
      item.quantity = null
    });
    this.doctor = null;
    this.notes = null;
    // this.location = null;
    const finishedToast = this.toastCtrl.create({
      message: 'Your request completed successfully',
      duration: 3000
    });
    finishedToast.present();
  }

  createOrderNumber(number: number) {
    return "ORD" + ("0000" + number).slice(-5);
  }
}



// WEBPACK FOOTER //
// ./src/pages/supplies/supplies.ts